import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dance',
  templateUrl: './dance.component.html',
  styleUrls: ['./dance.component.scss']
})
export class DanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
